module.exports = __webpack_public_path__ + "img/amm-oro.455fe0f8.png";